<script lang="ts">
  import { omit } from 'shared/src/utils/omit';

  import { twMerge } from 'tailwind-merge';

  let clazz: string = '';
  export { clazz as class };
  export let href: string;

  interface $$Props extends Partial<HTMLAnchorElement> {
    class?: string;
    href: string;
  }

  interface $$Events extends Partial<HTMLButtonElement> {}

  const defaultLinkStyle = ['text-blue', 'hover:underline'];

  $: mergedClass = twMerge(...defaultLinkStyle, ...clazz.split(' '));
</script>

<a class={mergedClass} {href} {...omit($$props, 'class')}><slot /></a>
